import { makeStyles } from 'transfix-ui/core'
import { brandColors, theme } from 'transfix-ui/theme'

export const useCarrierProfileHeaderStyles = makeStyles(() => ({
  inReview: {
    color: brandColors.coolGray5,
  },
  ml: {
    marginLeft: theme.spacing(1),
  },
  mr: {
    marginRight: theme.spacing(1),
  },
  header: {
    marginBottom: theme.spacing(2.5),
  },
  top: {
    marginBottom: theme.spacing(2),

    [theme.breakpoints.up('md')]: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
    },
  },
  nameWrapper: {
    '& > h3': {
      display: 'inline',
    },
  },
  carrierAction: {
    marginTop: theme.spacing(1),

    [theme.breakpoints.up('md')]: {
      marginTop: 0,
      marginLeft: theme.spacing(1.5),
    },
  },
  iconLink: {
    display: 'flex',
    alignItems: 'center',
  },
  infoWrapper: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    marginBottom: theme.spacing(0.5),

    [theme.breakpoints.up('md')]: {
      marginBottom: theme.spacing(1),
    },
  },
  divider: {
    background: brandColors.coolGray3,
    borderRadius: '50%',
    height: theme.spacing(0.5),
    width: theme.spacing(0.5),
    margin: `0 ${theme.spacing(1.5)}`,
  },
  teamInfo: {
    display: 'flex',
    alignItems: 'center',
    flex: '0 0 100%',
    marginTop: theme.spacing(0.5),

    [theme.breakpoints.up('md')]: {
      flex: '0 1 auto',
      marginTop: theme.spacing(0),
    },
  },
  bottom: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: theme.spacing(1.5),

    [theme.breakpoints.up('md')]: {
      marginTop: theme.spacing(0),
      flexDirection: 'row',
      alignItems: 'center',
    },
  },
  statusWrapper: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    marginBottom: theme.spacing(1.5),

    [theme.breakpoints.up('md')]: {
      marginBottom: theme.spacing(0),
    },
  },
  contactSupport: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    marginTop: theme.spacing(0.5),
  },
}))
